<template>
  <div class="cc-dropzone-wrap">
    <div
      class="cc-dropzone"
      :class="{ 'is-over': isOver, 'has-file': Boolean(file) }"
      role="button"
      tabindex="0"
      @click="openPicker"
      @keydown.enter.prevent="openPicker"
      @dragenter.prevent="onDragEnter"
      @dragover.prevent="onDragEnter"
      @dragleave.prevent="onDragLeave"
      @drop.prevent="onDrop"
    >
      <input
        ref="fileInput"
        class="cc-dropzone__input"
        type="file"
        :accept="accept"
        :disabled="disabled"
        @change="onPick"
      >
      <feather-icon
        icon="UploadCloudIcon"
        size="28"
        class="cc-dropzone__icon"
      />
      <p class="cc-dropzone__title">
        {{ $t('convertCoordinates.file.dropTitle') }}
      </p>
      <p class="cc-dropzone__sub">
        {{ $t('convertCoordinates.file.dropHint') }}
      </p>
      <span class="cc-dropzone__btn">{{ $t('convertCoordinates.file.browse') }}</span>
    </div>

    <div
      v-if="file"
      class="cc-file"
    >
      <div class="cc-file__meta">
        <feather-icon
          icon="FileTextIcon"
          size="18"
        />
        <div>
          <strong>{{ file.name }}</strong>
          <span>{{ sizeLabel }}</span>
        </div>
      </div>
      <button
        type="button"
        class="cc-icon-btn"
        :disabled="disabled"
        :title="$t('common.clear')"
        @click.stop="$emit('remove')"
      >
        <feather-icon
          icon="XIcon"
          size="16"
        />
      </button>
    </div>

    <p class="cc-hint">
      {{ $t('convertCoordinates.file.csvHint') }}
    </p>
  </div>
</template>

<script>
import { ALLOWED_FILE_EXTENSIONS } from '@/api/coordinate-conversion/types'
import { formatFileSize } from '../utils/coordinateRows'

export default {
  name: 'CoordinateFileDropzone',
  props: {
    file: {
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOver: false,
      dragCount: 0,
    }
  },
  computed: {
    accept() {
      return ALLOWED_FILE_EXTENSIONS.map(ext => `.${ext}`).join(',')
    },
    sizeLabel() {
      return this.file ? formatFileSize(this.file.size) : ''
    },
  },
  methods: {
    openPicker() {
      if (this.disabled) return
      this.$refs.fileInput.click()
    },
    onPick(event) {
      const picked = event.target.files && event.target.files[0]
      if (picked) this.$emit('select', picked)
      event.target.value = ''
    },
    onDragEnter() {
      if (this.disabled) return
      this.dragCount += 1
      this.isOver = true
    },
    onDragLeave() {
      this.dragCount = Math.max(0, this.dragCount - 1)
      if (this.dragCount === 0) this.isOver = false
    },
    onDrop(event) {
      this.dragCount = 0
      this.isOver = false
      if (this.disabled) return
      const dropped = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0]
      if (dropped) this.$emit('select', dropped)
    },
  },
}
</script>
